module.exports = __webpack_public_path__ + "img/license_image8.a8c87886.png";